import React from 'react';
import logo from './logo.svg';
import './App.css';

class EmojiView extends React.Component {
	
  handleSubmit = (user) => {
  }
  
  // Why isn't it displaying the icons even at 3 at all?
  
  constructor(props) {
		super(props);
		this.state = {
			correctQuestionCount : props.correctQuestionCount
		}
//		this.correctQuestionCount = props.correctQuestionCount;
	//	alert("this.correctQuestionCount = " + this.props.correctQuestionCount);
  }
  
  gotOneRight() {
	  this.setState({correctQuestionCount : (this.state.correctQuestionCount + 1)});
  }
  
  gotOneWrong() {
	  this.setState({correctQuestionCount : 0});
  }
  
  render() {
	  let correctQuestionCount = this.props.correctQuestionCount;
	  
	  return (
		<div className="App">
			<div className="icon-box">
		{(correctQuestionCount > 0) ? 
			<div alt="star" className="icon-badge">&#11088;</div> : <div/>
		}
		{(correctQuestionCount > 3) ? 
			<div alt="shooting star" className="icon-badge">&#127776;</div> : <div/>
		}
		{(correctQuestionCount > 6) ? 
			<div alt="pointing up" className="icon-badge">&#9757;</div> : <div/>
		}
		{(correctQuestionCount > 9) ? 
			<div alt="check" className="icon-badge">&#9989;</div> : <div/>
		}
		{(correctQuestionCount > 12) ? 
			<div alt="stars" className="icon-badge">&#10024;</div> : <div/>
		}
		{(correctQuestionCount > 15) ? 
			<div alt="galaxy" className="icon-badge">&#127756;</div> : <div/>
		}
		{(correctQuestionCount > 18) ? 
			<div alt="grapes" className="icon-badge">&#127815;</div> : <div/>
		}
		{(correctQuestionCount > 21) ? 
			<div alt="third" className="icon-badge">&#129353;</div> : <div/>
		}
		{(correctQuestionCount > 24) ? 
			<div alt="bullseye" className="icon-badge">&#127919;</div> : <div/>
		}
		{(correctQuestionCount > 27) ? 
			<div alt="ear" className="icon-badge">&#128066;</div> : <div/>
		}
		{(correctQuestionCount > 30) ? 
			<div alt="crown" className="icon-badge">&#128081;</div> : <div/>
		}
		{(correctQuestionCount > 33) ? 
			<div alt="100" className="icon-badge">&#128175;</div> : <div/>
		}
		{(correctQuestionCount > 36) ? 
			<div alt="fire" className="icon-badge">&#128293;</div> : <div/>
		}
		{(correctQuestionCount > 39) ? 
			<div alt="prayerhouse" className="icon-badge">&#x1F6D0;</div> : <div/>
		}
		{(correctQuestionCount > 42) ? 
			<div alt="second" className="icon-badge">&#129352;</div> : <div/>
		}
		{(correctQuestionCount > 45) ? 
			<div alt="lion" className="icon-badge">&#129409;</div> : <div/>
		}
		{(correctQuestionCount > 48) ? 
			<div alt="heart" className="icon-badge">&#129505;</div> : <div/>
		}
		{(correctQuestionCount > 51) ? 
			<div alt="cool" className="icon-badge">&#127378;</div> : <div/>
		}
		{(correctQuestionCount > 54) ? 
			<div alt="sunset" className="icon-badge">&#127749;</div> : <div/>
		}
		{(correctQuestionCount > 57) ? 
			<div alt="sunsmile" className="icon-badge">&#127774;</div> : <div/>
		}
		{(correctQuestionCount > 60) ? 
			<div alt="exclaim" className="icon-badge">&#10071;</div> : <div/>
		}
		{(correctQuestionCount > 63) ? 
			<div alt="explosion" className="icon-badge">&#128165;</div> : <div/>
		}
		{(correctQuestionCount > 66) ? 
			<div alt="first" className="icon-badge">&#129351;</div> : <div/>
		}
		{(correctQuestionCount > 69) ? 
			<div alt="prayer" className="icon-badge">&#128591;</div> : <div/>
		}
			</div>
			
		</div>
	  );
  }
}

export default EmojiView;
